import { Link } from 'react-router-dom';

import { useDocumentTitle } from '../lib/useDocumentTitle';

export function Terms() {
  useDocumentTitle('Neomaris | Terms of service');

  return (
    <section className="legal-prose">
      <h2>Terms of service</h2>
      <p className="legal-date">Effective date: September 30, 2026</p>

      <h3>1. Acceptance of terms</h3>
      <p>
        By accessing or using the Neomaris platform (&quot;Service&quot;), you agree to be bound by
        these Terms of Service. If you do not agree, you may not use the Service.
      </p>

      <h3>2. Description of service</h3>
      <p>
        Neomaris provides intelligent boat monitoring software that connects to vessel sensors and
        systems to deliver real-time alerts, diagnostics, and status information. The Service
        includes web and mobile applications, cloud-based data processing, and integration with
        onboard hardware.
      </p>

      <h3>3. User accounts</h3>
      <p>
        You must create an account to use the Service. You are responsible for maintaining the
        confidentiality of your credentials and for all activity under your account. You agree to
        provide accurate information and to notify us promptly of any unauthorized use.
      </p>

      <h3>4. Acceptable use</h3>
      <p>You agree not to:</p>
      <ul>
        <li>Use the Service for any unlawful purpose</li>
        <li>Attempt to interfere with or disrupt the Service or its infrastructure</li>
        <li>Reverse-engineer, decompile, or disassemble any part of the Service</li>
        <li>Share your account credentials with unauthorized parties</li>
        <li>Use the Service in a manner that could endanger persons or property</li>
      </ul>

      <h3>5. Safety disclaimer</h3>
      <p>
        The Service is intended as a supplementary monitoring tool only. It does not replace proper
        seamanship, manual monitoring, or required safety equipment. You remain solely responsible
        for the safe operation of your vessel at all times. Alerts and data provided by the Service
        may be delayed, incomplete, or inaccurate due to sensor limitations, connectivity issues, or
        software conditions. Answers and assessments from Neo, the Neomaris assistant, and the AI
        Watch are generated by AI models and can be wrong; check anything safety-critical against
        your instruments, your equipment&apos;s documentation, or a qualified professional before
        acting on it.
      </p>

      <h3>6. Intellectual property</h3>
      <p>
        All content, software, and technology comprising the Service are owned by Neomaris or its
        licensors and are protected by applicable intellectual property laws. You are granted a
        limited, non-exclusive, non-transferable license to use the Service for its intended
        purpose.
      </p>

      <h3>7. Limitation of liability</h3>
      <p>
        To the fullest extent permitted by law, Neomaris and its officers, directors, employees, and
        agents shall not be liable for any indirect, incidental, special, consequential, or punitive
        damages arising from your use of or inability to use the Service, including but not limited
        to damage to vessels, equipment, or property.
      </p>

      <h3>8. Disclaimer of warranties</h3>
      <p>
        The Service is provided &quot;as is&quot; and &quot;as available&quot; without warranties of
        any kind, whether express or implied, including but not limited to implied warranties of
        merchantability, fitness for a particular purpose, and non-infringement.
      </p>

      <h3>9. Termination</h3>
      <p>
        We may suspend or terminate your access to the Service at any time, with or without cause.
        You may delete your account at any time. Upon termination, your right to use the Service
        ceases immediately.
      </p>

      <h3>10. Changes to terms</h3>
      <p>
        We may update these Terms from time to time. We will notify you of material changes by
        posting the revised Terms on this page with an updated effective date. Your continued use of
        the Service after changes take effect constitutes acceptance of the revised Terms.
      </p>

      <h3>11. Governing law</h3>
      <p>
        These Terms are governed by and construed in accordance with the laws of the State of
        Washington, United States, without regard to its conflict of law provisions.
      </p>

      <h3>12. Contact</h3>
      <p>
        If you have questions about these Terms, please contact us at{' '}
        <a className="link" href="mailto:support@tombolomarine.com">
          support@tombolomarine.com
        </a>
        .
      </p>

      <p className="legal-back">
        <Link className="link" to="/">
          &larr; Back to home
        </Link>
      </p>
    </section>
  );
}
